
$('.download-ninja-form').on('click', function(e) {
    let title = $(this).attr('data-title');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "ccFileDownloadNinjaforms",
        "ccFormTitle" : title,
        "ccLeadTypeGroup" : "Download form"  
    });
});